import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import React from "react";
import styled from "styled-components";
import { textStyle, spacing } from "../../dimensions";
var SimpleSeatInfo = function SimpleSeatInfo(_ref) {
  var section = _ref.section,
    row = _ref.row,
    seat = _ref.seat;
  var locationsParts = [].concat(_toConsumableArray(section !== null && section !== void 0 && section.value ? [section] : []), _toConsumableArray(row !== null && row !== void 0 && row.value ? [row] : []), _toConsumableArray(seat !== null && seat !== void 0 && seat.value ? [seat] : []));
  return /*#__PURE__*/React.createElement(StyledSeatInfo, null, /*#__PURE__*/React.createElement(RowList, null, locationsParts.map(function (item, index) {
    if (!item) return null;
    return /*#__PURE__*/React.createElement(RowItem, {
      key: item.title
    }, /*#__PURE__*/React.createElement(LocationLabel, null, item.title.toUpperCase()), /*#__PURE__*/React.createElement(LocationDescription, null, item === null || item === void 0 ? void 0 : item.value, index < locationsParts.length - 1 && /*#__PURE__*/React.createElement("span", null, ",")));
  })));
};
export default SimpleSeatInfo;
var StyledSeatInfo = styled.div.withConfig({
  displayName: "SimpleSeatInfo__StyledSeatInfo",
  componentId: "sc-1b9h51s-0"
})(["", ";margin:0;color:", ";"], textStyle.snowdon, function (props) {
  return props.theme.text.secondary;
});
var RowList = styled.dl.withConfig({
  displayName: "SimpleSeatInfo__RowList",
  componentId: "sc-1b9h51s-1"
})(["display:flex;gap:", ";"], spacing.lounge);
var RowItem = styled.div.withConfig({
  displayName: "SimpleSeatInfo__RowItem",
  componentId: "sc-1b9h51s-2"
})(["display:flex;gap:", ";"], spacing.lounge);
var LocationLabel = styled.dt.withConfig({
  displayName: "SimpleSeatInfo__LocationLabel",
  componentId: "sc-1b9h51s-3"
})(["margin:0;"]);
var LocationDescription = styled.dd.withConfig({
  displayName: "SimpleSeatInfo__LocationDescription",
  componentId: "sc-1b9h51s-4"
})(["margin:0;"]);